import { render, staticRenderFns } from "./DefaultFullWidth.vue?vue&type=template&id=03f0ff6e&scoped=true"
import script from "./DefaultFullWidth.vue?vue&type=script&lang=js"
export * from "./DefaultFullWidth.vue?vue&type=script&lang=js"
import style0 from "./DefaultFullWidth.vue?vue&type=style&index=0&id=03f0ff6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0ff6e",
  null
  
)

export default component.exports